var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg30(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3343 4L4 11.3343H18.6657V17.9328H26V4H11.3343Z",
    fill: "#4C4D4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3343 18.6654V12.0669H4V25.9997H18.6657L26 18.6654H11.3343Z",
    fill: "#4C4D4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg30);
export default __webpack_public_path__ + "static/media/대신증권-30.6888c03eea073c094c45b85baf507d53.svg";
export { ForwardRef as ReactComponent };